import React, { useContext } from "react";
import CopyButton from "../CopyButton";
import { CodeWindow } from "../pages/CodeFeature";
import LanguageContext from "../ContextProviders/LanguageContext";
import Prism from "prismjs";
import { Flex } from "@radix-ui/themes";

const typescript = "npm install @covalenthq/client-sdk";
const python = "pip3 install covalent-api-sdk";

const Installer = ({ script }) => {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref.current) {
            Prism.highlightElement(ref.current, false);
        }
    }, [script]);

    return <><div className="wrapper">
        <div >$ <span ref={ref} className={`language-shell`}>{script}</span></div><div><CopyButton text={script}></CopyButton></div>
    </div><style jsx>
        {`
        .wrapper {
            padding: 0.75rem 1rem;
            font-family: var(--mono);
            background: var(--code-background);
            margin: 0.25rem;
            font-size: var(--font-size-2);
            border-radius: 0rem 0rem 0.5rem 0.5rem;
            display: flex;
            justify-content: space-between;
        }
    `}
    </style></>;
};

export const SDKInstaller = () => {
    // const languages = [
    //     "TypeScript",
    //     "Python"
    // ];
    const languageContext: any = useContext(LanguageContext);

    const script = {
        "TypeScript": typescript,
        "Python": python
    };

    return <>
        <div className="container">
            <Flex direction="column" gap="3" mb="6">
                {/* <h2>Developer Libraries</h2> */}
                {/* <p>Covalent provides native SDKs in several programming languages. Select a language below to explore how to begin using it for your application.</p> */}
                {/* <div className="button-container">
                    {
                        languages.map((lang) => {
                            return <div key={lang}><ToggleButton selected={lang === languageContext?.language} onClick={() => languageContext.setLanguage(lang)}>{lang}</ToggleButton></div>;
                        })
                    }
                </div> */}
                {/* <p>Install the {languageContext?.language} SDK using the command below.</p> */}
                <CodeWindow children={<Installer script={script[languageContext?.language]}/>} hasAppBar appBarTab={languageContext?.language} />
                {/* <p className="small">Can't find the SDK you're looking for? <Link href="/support/">Reach out to us</Link> to request an SDK.</p> */}
            </Flex>
        </div>
        <style jsx>
            {`
                .small {
                    font-size: var(--font-size-2);
                    opacity: 0.6;
                }
                .button-container {
                    display: flex;
                    gap: 1rem;
                }
                button {
                    background: var(--code-background);
                    border: 1px solid var(--code-border);
                    padding: 0.5rem 0.75rem;
                    border-radius: var(--border-radius);
                    display: flex;
                    place-items: center;
                    gap: 0.5rem;
                    font-size: var(--font-size-2);
                }
            `}
        </style></>;
};
